export enum CrudFormFixButton {
  DEFAULT = 'Fix',
  KEBAB_CASE = 'Convert to Kebab Case',
  CAPITAL_LETTER = 'Convert to Capital Letter',
  PASCAL_CASE = 'Convert to Pascal Case',
  CAMEL_CASE = 'Convert to Camel Case',
  LOWERCASE_LETTER = 'Convert to Lowercase Letter',
  TITLE_CASE = 'Convert to Title Case',
  FIX_NAME = 'Fix Project Name'
}

